import React from 'react';

import { isEmptyObject } from '@atlas/core';
import { useSportsbookFilterState } from '@atlas/ui/build/sportsbook/SportsbookFilter/useSportsbookFilterState';

const SportCategoryFilter = ({
  ItemComponent,
  clickedCategory,
  onClick,
  options,
  setClickedCategoryId,
  value,
  valueProperty,
}) => {
  const { listRef } = useSportsbookFilterState(options);
  const renderItems = React.useMemo(() => {
    if (isEmptyObject(options)) {
      return null;
    }
    return Object.values(options)
      .slice(0, options.length)
      .map(option => (
        <div className="sportsbook-filter-list-item-container" key={option[valueProperty]}>
          <ItemComponent
            clickedCategory={clickedCategory}
            imagePath={option.imagePaths?.FLAG}
            onClick={onClick}
            option={option}
            setClickedCategoryId={setClickedCategoryId(option.id)}
            value={value}
          />
        </div>
      ));
  }, [options, valueProperty, ItemComponent, onClick, setClickedCategoryId, value]);
  return (
    <div className="sportsbook-filter sport-filter sport-categories-filter">
      <div className="sportsbook-filter-content">
        <div className="sporsbook-filter-list" ref={listRef}>
          {renderItems}
        </div>
      </div>
    </div>
  );
};

export default SportCategoryFilter;
